import { render, staticRenderFns } from "./tool-card.vue?vue&type=template&id=3be8f7e4&scoped=true&"
import script from "./tool-card.vue?vue&type=script&lang=js&"
export * from "./tool-card.vue?vue&type=script&lang=js&"
import style0 from "./tool-card.vue?vue&type=style&index=0&id=3be8f7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be8f7e4",
  null
  
)

export default component.exports